import React, { useEffect } from "react"
import { Styled } from './styled'
import { useLocation } from 'react-router-dom'

export interface IProps {
  id?: string,
  children?: React.ReactNode,
  size?: string,
  title?: string | React.ReactNode,
  subTitle?: string | React.ReactNode,
  bottomLine?: boolean,
  className?: string,
  style?: any
}

const Screen: React.FC<IProps> = (props: IProps) => {
  const location = useLocation()

  useEffect(() => {
    if (location?.hash) {
      const element = document.querySelector(location.hash)
      if (element) element.scrollIntoView()
    }
  }, [location])

  return (
    <Styled.Screen id={props.id} size={props.size} style={props.style || {}}>
      {
        props.title &&
        props.size === 'large'
          ? <Styled.TitleH1>{props.title}</Styled.TitleH1>
          : <Styled.TitleH2>{props.title}</Styled.TitleH2>
        || null
      }
      {
        props.subTitle && <Styled.SubTitle>{props.subTitle}</Styled.SubTitle>
      }
      {props.children}
      {
        props.bottomLine && <Styled.BottomLine />
      }
    </Styled.Screen>
  )
}

export { Screen }
